<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div>
  <h2>Test Groups</h2>
  <mat-form-field class="new-exp-form-field">
    <mat-label>Test Groups</mat-label>
    <mat-select #selectTestGroup multiple
    [matTooltip]="helpMessagesService.experimentCommonInputFields.SELECT_TEST_GROUPS">
      <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}" (change)="
        toggleAllSelection()">Select All</mat-checkbox>
      <mat-select-trigger>
        <mat-chip-listbox>
          <mat-chip *ngFor="let selectedTestGroup of getCurrentlySelectedTestGroups()"
            [removable]="true" (removed)="onTestGroupRemoved(selectedTestGroup)">
            {{selectedTestGroup}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-listbox>
      </mat-select-trigger>
      <mat-option *ngFor="let testGroup of testGroupsSelection" [value]="testGroup"
        (click)="updateAllSelected()">{{testGroup}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>